import { string } from 'yup';

const obj = {
  field: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "",
      id: "targetAudience",
      placeholder: "SEO optimization services",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Target Audience",
      attr: "content",
      value: "",
      id: "tone",
      placeholder: "Small business owners",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required(" Target Audience is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Tone",
      attr: "content",
      value: "",
      id: "topic",
      placeholder: "Professional and informative.",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    { 
			title: "Content length", 
			attr: "content",  
			value: 250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("No Of Tokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
  ],

  example: [
    {
      title: "Topic or Keyword",
      attr: "content",
      value: "Driving",
      id: "targetAudience",
      placeholder: "SEO optimization services",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Topic or Keyword is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Target Audience",
      attr: "content",
      value: "Gamers",
      id: "tone",
      placeholder: "Small business owners",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Target Audience is Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    {
      title: "Tone",
      attr: "content",
      value: "professional",
      id: "topic",
      placeholder: "Professional and informative.",
      label: "Place some code above to understand how it works",
      type: "code",
      maxLength: 2000,
      yup: string().nullable().trim("Initially whitespace are not allowed").required("Tone is  Required"),
      // max: 100,
      min: 3,
      required: true,
      error: "",
      type: "textarea",
      example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
    },
    { 
			title: "Content length", 
			attr: "content",  
			value: 250, 
			id:"noOfTokens",
			placeholder: "250, 500,750,1000", 
			label: "Place some code above to understand how it works",
			type: "code",
			maxLength: 2000,
			yup: string().nullable().trim("Initially whitespace are not allowed").required("noOfTokens is Required"),

			// max: 100,
			min: 3,
			required: true,
			error: "",
			option:[250,500,750,1000],
			type: "dropdown",
			example: `function HelloWorld(text){ 
	let text || "Hello World"; 
	console.log(text);
	}`,
		},
  ],

  editor: {
    output: `1. Get behind the wheel and unlock your inner gamer with rrofessional targeting `, 
       
       
      
        
  },
};

export default obj;
